export enum API_RESOURCE {
  APPROACHES = 'approaches',
  ASSETS = 'assets',
  CLIENTS = 'clients',
  DOCUMENTS = 'documents',
  EMPLOYEES = 'employees',
  FEATURES = 'features',
  FILTERS = 'filters',
  PROJECTS = 'projects',
  REFERENCES = 'references',
}

export enum DocumentType {
  EMPLOYEE = 'employee',
  PROJECT = 'project',
}
